import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetGgr } from '../../store/thunk/setGetGgr';
import { setGetOperationsReplenishment } from '../../store/thunk/setGetOperationsReplenishment';
import {setGetOperationsWithdrawal} from '../../store/thunk/setGetOperationsWithdrawal';
import TableCasino from '../../../../../@casino/ui/table';
import {useStyles, columns, getRowsCashiers, getRowsCashiersOut} from './helpers';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const ReportFinance = () => {
    const dispatch = useDispatch();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetGgr({
            date_from: 0,
            date_to: new Date().getTime()
        }));
        dispatch(setGetOperationsReplenishment({
            order: 'payment',
            desc: false,
            date_from: 0,
            date_to: new Date().getTime()
        }));
        dispatch(setGetOperationsWithdrawal({
            order: 'payment',
            desc: false,
            date_from: 0,
            date_to: new Date().getTime()
        }))
    }, []);

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});

    const ggr = useSelector(state => state.ggr.view);
    const withdrawal = useSelector(state => state.ggr.list_withdrawal.withdrawal);
    const replenishment = useSelector(state => state.ggr.list_replenishment.replenishment);
    
    const rowsCashiers = React.useMemo(() => getRowsCashiers(replenishment), [replenishment]);
    const rowsCashiersOut = React.useMemo(() => getRowsCashiersOut(withdrawal), [withdrawal]);


    return (
        <div className={classes.root}>
            <Title label="Финансовый отчет" />
            <FormikContext.Provider value={formik}>
                <form>
                    <div className={classes.wrap}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetGgr({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                    }))
                                    dispatch(setGetOperationsReplenishment({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                    }))
                                    dispatch(setGetOperationsWithdrawal({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }
                                    formik.setFieldValue('date_to', date.getTime());
                                    dispatch(setGetGgr({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                    }))
                                    dispatch(setGetOperationsReplenishment({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                    }))
                                    dispatch(setGetOperationsWithdrawal({
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                    }))
                                    
                                }}
                            />
                        </div>
                    </div>
                </form>
            </FormikContext.Provider>
            <div className={classes.wrap}>
                <h3 className={classes.title}>GGR за период: </h3>
                <span className={classes.ggr}>
                    {ggr ? ggr.ggr.toFixed(2) : 0} ₽
                </span>
                <div>
                    <h3 className={classes.title}>Получено</h3>
                    <div>
                        <TableCasino
                            width={700}
                            columns={columns}
                            rows={rowsCashiers}
                        /> 
                    </div>
                </div>
                <div>
                    <h3 className={classes.title}>Выдано</h3>
                    <div>
                        <TableCasino
                            width={700}
                            columns={columns}
                            rows={rowsCashiersOut}
                        /> 
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default ReportFinance;